export default {"src":"/_next/static/media/trash.8f2941f6.svg","height":24,"width":24};